import fi from './fi.json';
import en from './en.json';

export default {
  fi,
  en,
};
